import HorizontalCard from "../productCards/horizontalCard";
import VerticalCard from "../productCards/verticalCard";
import {CashbackCustomerProductView, MembershipImage2, ToggleGif} from "../../../assets/assets";
import CTABanner from "../../generalComponents/banners/CTABanner";
import AdvanceCTABanner from "../../generalComponents/banners/advanceCTABanner";
import { useEffect, useState } from "react";
import {sendSlackMessageTracked} from "../../../models/notifications";



export default function SectionComponent(props) {
    const [isMobile, setIsMobile] = useState(false);

    useEffect(() => {
        const checkMobile = () => {
            setIsMobile(window.innerWidth < 768);
        };

        checkMobile(); // Initial check
        window.addEventListener("resize", checkMobile);


        sendSlackMessageTracked("Lead is visiting the Cashback Product page.", "#website-updates")
        return () => {
            window.removeEventListener("resize", checkMobile);
        };
    }, []);



    return (
        <div className="my-20 space-y-4">

            <div className="text-black text-[64px] p-32 responsive-section" style={{backgroundColor: "#f5f5f7"}}>
                <div className="flex items-center justify-center">
                    <div>
                        <h1 className="my-8 text-center section-heading-c" style={{fontWeight: "600"}}>
                            Designed for discovery.
                        </h1>

                        <div className="flex justify-center">
                            <div className="mt-20 w-4/5 space-y-4 section-inner">

                                <HorizontalCard
                                    // title="Stories and collections that inform, help, and inspire. Updated daily."
                                    title="Real stories, strategic guides, and curated tips. Always fresh. Always actionable."
                                    // title="Get fresh, actionable cashback success stories, strategic guides, and expert tips."
                                    description="Original insights from our rewards experts deliver everything from exclusive deal alerts to rare saving strategies. Tap the 'Explore' tab to discover top cashback influencers, unlock secret earning tricks, and see how retailers are transforming everyday spending."
                                    imageSource="https://firebasestorage.googleapis.com/v0/b/pabloo-inc.appspot.com/o/website_development%2Fcase-studies-pics%2FyeeSi.png?alt=media&token=31f74308-6857-4064-b83b-3d41cd2c4dc7"
                                    imagePosition={isMobile ? "top" : "right"}
                                />

                                {/*<HorizontalCard*/}
                                {/*    title="Customer life-cycles"*/}
                                {/*    description="Original stories by our editorial team bring you everything from exclusive world premieres to behind-the-scenes interviews. Tap the Today tab and read about influential developers and game creators, learn a few tips and tricks, or see how apps are changing how people work, play, and live."*/}
                                {/*    imageSource="https://www.notion.so/image/https%3A%2F%2Fprod-files-secure.s3.us-west-2.amazonaws.com%2F36e13cfa-1773-48c2-a26a-496790fc7c44%2F28e91e6b-c0af-4268-a20c-c3d0c8649c18%2Fimage.png?table=block&id=6ae0a483-80a5-4d8e-8a29-01dba3d3a887&spaceId=36e13cfa-1773-48c2-a26a-496790fc7c44&width=2000&userId=237fb6d8-9f66-4d89-926a-ada1edbe6efa&cache=v2"*/}
                                {/*    imagePosition="right"*/}
                                {/*/>*/}

                                <div className="flex space-x-4 responsive-card-group">
                                    <div style={{maxWidth: '49%'}}>
                                        <VerticalCard
                                            title={
                                                <div>
                                                    Over 12K Shopify
                                                    <img className="w-20"
                                                         src="https://cdn3.iconfinder.com/data/icons/social-media-2068/64/_shopping-512.png"/>
                                                    merchants and online retailers.
                                                </div>
                                            }
                                            imagePosition="bottom"
                                            superSizeTitle={true}
                                            cardColor="black"
                                        />
                                    </div>

                                    <div style={{maxWidth: '49%'}}>
                                        <VerticalCard
                                            title="Cashback on every order."
                                            description="Discover events on the Today, Games, and Apps tabs on the App Store. Or find them via search and on app product pages."
                                            // imageSource={CashbackCustomerProductView}
                                            imageSource={MembershipImage2}
                                            imageMargin="24px"
                                            imagePosition="bottom"
                                        />
                                    </div>
                                </div>

                                <HorizontalCard
                                    // title="Explore in-app events like movie premieres, gaming competitions, and livestreams."
                                    title="Start with an original template optimized for conversion. like special events, gaming competitions, and livestreams."
                                    description="Use any of our pre-built cashback templates that convert 30% better than generic offers."
                                    imageSource="https://cdn.shopify.com/s/files/1/0070/7032/articles/Image1_2048x2048_7ebeafc0-21df-4d6f-b1f6-c205149ba3c7.png?v=1729517839&originalWidth=1848&originalHeight=782&width=1800"
                                    imagePosition="top"
                                />

                                <div className="flex space-x-4 responsive-card-group">
                                    <div style={{maxWidth: '49%'}}>
                                        <VerticalCard
                                            title="Easily search across all cashback activites."
                                            description="Our comprehensive search feature offers suggestions and helpful hints, and provides results with in‑line video previews, editorial stories, tips and tricks, and lists."
                                            imageSource="https://www.apple.com/v/app-store/b/images/overview/icon_search__d0w979yulru6_large_2x.png"
                                            imagePosition="top"
                                            imageHeight="200px"
                                            imageMargin="20px"
                                        />
                                    </div>

                                    <div style={{maxWidth: '49%'}}>

                                        <div className="card-wrapper">
                                            <VerticalCard
                                                title="100% of activities screened for fraud."
                                                description={
                                                    <div>
                                                        100% of cashback activities are screened for fraud. Premium
                                                        members
                                                        can enable the <span
                                                        className="italic">manual approval</span> feature to confirm all
                                                        cashback activities before issuance.
                                                    </div>
                                                }
                                                cardColor="blue"
                                                superSizeTitle={true}
                                            />
                                        </div>
                                    </div>
                                </div>

                                <HorizontalCard
                                    // title="Security for every app. At every level."
                                    title="Easy Toggle"
                                    description="Easy Toggle allows for seamless on/off switching without interrupting business flow."
                                    imageSource={ToggleGif}
                                    superSizeTitle={true}
                                    imagePosition={isMobile ? "top" : "right"}
                                />

                                <div className="flex space-x-4 responsive-card-group-fix">
                                    <div className="card-wrapper">
                                        <VerticalCard
                                            title="12,500+ storefronts in 40+ languages."
                                            // description="Translates to any language"
                                            cardColor="black"
                                            superSizeTitle={true}
                                        />
                                    </div>

                                    <div className="card-wrapper">
                                        <VerticalCard
                                            title="100% of activities screened for fraud."
                                            description={
                                                <div>
                                                    100% of cashback activities are screened for fraud. Premium members
                                                    can enable the <span
                                                    className="italic">manual approval</span> feature to confirm all
                                                    cashback activities before issuance.
                                                </div>
                                            }
                                            cardColor="blue"
                                            superSizeTitle={true}
                                        />
                                    </div>
                                </div>


                                <HorizontalCard
                                    title="Get the details on every app."
                                    description="App product pages give you the information you need when deciding what to download. From more videos to rankings and reviews, there are loads of ways to help you pick the app that’s right for you."
                                    imageSource="https://cdn.shopify.com/s/files/1/0070/7032/articles/Banner_-_1848_x_784_-_Option_D.png?v=1729263104&originalWidth=1848&originalHeight=782&width=1800"
                                    imagePosition="top"
                                />
                            </div>
                        </div>
                    </div>
                </div>


            </div>


            <div className="flex justify-center px-4 md:px-0">
                <div className="w-full max-w-screen-lg">
                    <AdvanceCTABanner
                        // text={<div>What do you focus on?<br/>Sign up for free.</div>} ctaString="Start now for free"
                        text={<div>How hard will you go?<br/>Sign up for free.</div>}
                        ctaString="Start now for free"
                        imageSource="https://planzer.io/wp-content/uploads/2022/12/planzer-tasks-solved.svg"
                    />
                </div>
            </div>

            <div className="text-black text-[64px] p-32 responsive-section" style={{backgroundColor: "#f5f5f7"}}>
                <div className="flex items-center justify-center">
                    <div>
                        <h1 className="my-8 text-center section-heading-c" style={{fontWeight: "600"}}>
                            <div>Cashback is a Shopify retention tool.</div>
                            <div>Functioning as an engagement engine.</div>
                        </h1>

                        <div className="flex justify-center">
                            <div className="mt-20 w-4/5 space-y-4 section-inner">
                                <HorizontalCard
                                    title="Fraud prevention."
                                    description="We ensure that apps come from known sources, are free of known malware, and haven’t been tampered with at the time of installation or launch."
                                    imageSource="https://www.enactsoft.com/resources/wp-content/uploads/2025/02/visual-selection-6-2048x1429.png"
                                    imagePosition={isMobile ? "top" : "left"}
                                    superSizeTitle={true}
                                />

                                <div className="flex space-x-4 responsive-card-group">
                                    <div style={{maxWidth: '49%'}}>
                                        <VerticalCard
                                            title="Exclude gift cards, sale items, or low margin products. So you can reward generously without sacrificing profits."
                                            cardColor="blue"
                                            superSizeTitle={false}
                                        />
                                    </div>
                                    <div style={{maxWidth: '49%'}}>
                                        <VerticalCard
                                            title="Over 16K installations cashback technologies."
                                            cardColor="black"
                                            superSizeTitle={true}
                                        />
                                    </div>
                                </div>

                                <HorizontalCard
                                    title="Premium Memberships"
                                    description="Premium members can integrate with the Pabloo Memberships platform to offer tiered cashback. The Memberships platform is an exclusive way to reward your best customers with higher earnings while incentivizing others to level up."
                                    imageSource="https://www.apple.com/v/app-store/b/images/overview/privacy_data__fopy0xxbbkuy_large_2x.jpg"
                                    imagePosition={isMobile ? "top" : "left"}
                                    superSizeTitle={true}
                                />

                                <div className="flex space-x-4 responsive-card-group">
                                    <div style={{maxWidth: '49%'}}>
                                        <VerticalCard
                                            title="Dynamic expiry dates"
                                            description="Create urgency and increase redemptions by setting expiration dates for cashback credits. Choose any timeframe that fits your program goals."
                                            imageSource="https://www.enactsoft.com/resources/wp-content/uploads/2025/02/visual-selection-16.png"
                                            imagePosition={isMobile ? "bottom" : "top"}
                                            // imageHeight="330px"
                                            imageMargin="40px"
                                            superSizeTitle={true}
                                        />
                                    </div>
                                    <div style={{maxWidth: '49%'}}>
                                        <VerticalCard
                                            title="Dynamic expiry dates"
                                            description="Create urgency and increase redemptions by setting expiration dates for cashback credits. Choose any timeframe that fits your program goals."
                                            imageSource="https://www.enactsoft.com/resources/wp-content/uploads/2025/02/visual-selection-7.png"
                                            imagePosition={isMobile ? "top" : "bottom"}
                                            // imageHeight="330px"
                                            imageMargin="40px"
                                            superSizeTitle={true}
                                        />
                                    </div>
                                </div>

                                <div className="flex space-x-4 responsive-card-group">
                                    <div style={{maxWidth: '49%'}}>
                                        <VerticalCard
                                            title="Dynamic expiry dates"
                                            description="Create urgency and increase redemptions by setting expiration dates for cashback credits. Choose any timeframe that fits your program goals."
                                            imageSource="https://www.apple.com/v/app-store/b/images/overview/trust_guidelines__dcbhrjxc09km_large_2x.jpg"
                                            imagePosition={isMobile ? "top" : "top"} //Can be changed at will to bottom for desktop view

                                            // imageHeight="330px"
                                            // imageMargin="200px"
                                            superSizeTitle={true}
                                        />
                                    </div>
                                    <div style={{maxWidth: '49%'}}>
                                        <VerticalCard
                                            title="Every week, over 500 dedicated experts around the world review over 100K apps."
                                            imagePosition="top"
                                            superSizeTitle={true}
                                            cardColor="black"
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>


            {/*         Responsive Styles */}
            <style>
                {`
                        @media (max-width: 767px) {
                            .responsive-section {
                                font-size: 28px !important;
                                padding: 28px !important;
                            }

                            .section-heading-c {
                                font-size: 48px !important;
                                line-height: 1.3 !important;
                            }

                            .section-inner {
                                width: 100% !important;
                                margin-top: 2rem !important;
                            }

                            .responsive-card-group {
                                flex-direction: column !important;
                                gap: 1.5rem !important;
                                
                            }

                            .responsive-card-group > div {
                                max-width: 100% !important;
                                margin-left: 0 !important;
                            }

                            .responsive-card-group-fix {
                                flex-direction: column !important;
                                margin-top: 1.5rem !important;
                                gap: 1.5rem !important;
                            }

                            .responsive-card-group-fix > .card-wrapper {
                                width: 100% !important;
                                margin-left: 0 !important;
                            }
                        }
                    `}
            </style>

        </div>
    )
}